(() => {
  const tag = 'carisma-delivery-options';
  if(customElements.get(tag))return;
  class DeliveryOptions extends HTMLElement {
    connectedCallback(){
      this.disconnectedCallback();this.abort=new AbortController();
      const on=(target,event,fn)=>target?.addEventListener(event,fn,{signal:this.abort.signal});
      this.root=this.closest('[data-product-page]')||this;
      this.tabs=[...this.querySelectorAll('[data-mode]')];this.cities=[...this.querySelectorAll('[data-city]')];
      this.tabs.forEach((tab,i)=>{
        on(tab,'click',()=>this.selectTab(tab.dataset.mode));
        on(tab,'keydown',e=>{let index;if(e.key==='ArrowRight')index=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')index=(i+this.tabs.length-1)%this.tabs.length;else if(e.key==='Home')index=0;else if(e.key==='End')index=this.tabs.length-1;else return;e.preventDefault();this.selectTab(this.tabs[index].dataset.mode);this.tabs[index].focus();});
      });
      this.cities.forEach(city=>on(city,'click',()=>this.selectCity(city.dataset.city)));
      on(document,'shopify:block:select',event=>{
        const id=event.detail?.blockId;
        const item=[...this.querySelectorAll('[data-delivery-item]')].find(item=>item.dataset.deliveryItem===id);
        const selectedTab=this.tabs.find(tab=>tab.getAttribute('data-shopify-editor-block')?.includes(id));
        const panel=item?.closest('[data-panel]');
        if(panel)this.selectTab(panel.dataset.panel);
        if(selectedTab)this.selectTab(selectedTab.dataset.mode);
        const city=this.cities.find(item=>item.dataset.city===id);
        const brand=[...this.querySelectorAll('[data-brand-id]')].find(item=>item.dataset.brandId===id);
        const cityId=city?.dataset.city||brand?.closest('[data-city-panel]')?.dataset.cityPanel;
        if(cityId){this.selectTab('quick');this.selectCity(cityId);}
      });
      this.renderAssignments();
      this.selectTab(this.dataset.defaultTab||'pan');
      if(this.cities.length)this.selectCity(this.cities[0].dataset.city);
      else {const message=this.querySelector('[data-city-message]');if(message)message.textContent=message.dataset.empty||'No cities have been configured yet.';}
    }
    selectTab(mode){if(!this.tabs.some(tab=>tab.dataset.mode===mode))mode=this.tabs[0]?.dataset.mode;this.tabs.forEach(tab=>{const active=tab.dataset.mode===mode;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==mode);this.closest('vita-delivery')?.syncMobile?.();}
    selectCity(id){const city=this.cities.find(c=>c.dataset.city===id);if(!city)return;this.cities.forEach(city=>city.setAttribute('aria-pressed',String(city.dataset.city===id)));this.querySelectorAll('[data-city-panel]').forEach(p=>p.hidden=p.dataset.cityPanel!==id);const message=this.querySelector('[data-city-message]');if(message)message.textContent=city.dataset.availability||(message.dataset.prefix??'Quick-commerce links for')+' '+city.dataset.name;}
    renderAssignments(){
      const list=this.querySelector('[data-assignment-results]');
      if(!list)return;
      list.replaceChildren();
      const cities=[...this.querySelectorAll('[data-assignment-city]')].map(el=>el.dataset);
      const brands=[...this.querySelectorAll('[data-assignment-brand]')].map(el=>({...el.dataset,keys:el.dataset.locations.split(',').filter(Boolean)}));
      const add=text=>{const row=document.createElement('li');row.textContent=text;list.append(row);};
      if(!cities.length)add('Add a Delivery — City item to assign brands to a location.');
      cities.forEach(city=>{
        const names=brands.filter(brand=>brand.enabled==='true'&&brand.name&&brand.keys.includes(city.key)).map(brand=>brand.name);
        add(`${city.name||'Unnamed city'} [${city.key||'missing key'}]: ${city.enabled==='true'?(names.join(', ')||'No brands assigned'):'Hidden from quick delivery'}`);
        if(city.key&&cities.filter(other=>other.key===city.key).length>1)add(`Duplicate location key: ${city.key}. Use a unique key for each city.`);
      });
      brands.forEach(brand=>{
        if(brand.enabled!=='true'){add(`${brand.name||'Unnamed brand'}: disabled`);return;}
        if(!brand.name)add('A brand item is missing its name and will not appear.');
        if(!brand.keys.length)add(`${brand.name||'Unnamed brand'}: no location assigned`);
        brand.keys.forEach(key=>{if(!cities.some(city=>city.key===key))add(`${brand.name||'Unnamed brand'}: unknown location key "${key}"`);});
      });
    }
    disconnectedCallback(){this.abort?.abort();}
  }
  customElements.define(tag,DeliveryOptions);
})();

(() => {
  if(customElements.get('vita-delivery')) return;
  class VitaDelivery extends HTMLElement {
    connectedCallback() {
      if(this.abort) return;
      this.abort=new AbortController(); const options={signal:this.abort.signal};
      this.forms=[...this.querySelectorAll('[data-vita-form]')];
      this.root=this.closest('[data-product-page]')||this;
      this.mobile=this.querySelector('[data-vita-mobile]');
      // Older saved markup may have a form but no separate mobile bar.
      if(!this.mobile&&this.forms.length){
        this.mobile=document.createElement('div');
        this.mobile.className='vita-atc vita-mobile-atc';this.mobile.dataset.vitaMobile='';this.mobile.hidden=true;
        this.mobile.innerHTML='<div><strong data-vita-mobile-price></strong><small data-vita-mobile-name></small></div><button type="button" data-vita-mobile-submit></button><p data-vita-mobile-status role="status" aria-live="polite" hidden></p>';
      }
      // Theme animation/containment on ancestors can turn fixed positioning into
      // section-relative positioning and clip the CTA. Keep just the bar in a
      // scoped body-level host; its original form remains the sole cart owner.
      if(this.mobile){
        this.mobileHost=document.createElement('div');this.mobileHost.className='carisma-product-page carisma-mobile-cart-portal';this.mobileHost.style.display='contents';
        const skin=document.createElement('div');skin.className='vita-delivery';skin.style.display='contents';
        const source=getComputedStyle(this);
        for(const property of ['--vita-green','--vita-muted','--vita-line','--c-green','--c-muted','--font-body-family','--font-heading-family'])skin.style.setProperty(property,source.getPropertyValue(property));
        skin.append(this.mobile);this.mobileHost.append(skin);document.body.append(this.mobileHost);
      }
      this.mobileMedia=matchMedia('(max-width: 991px)');
      this.scrollReady=window.scrollY>=100;
      let scrollFrame=0;
      window.addEventListener('scroll',()=>{
        if(scrollFrame)return;
        scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;const ready=window.scrollY>=100;if(ready!==this.scrollReady){this.scrollReady=ready;this.syncMobile();}});
      },{...options,passive:true});
      this.abort.signal.addEventListener('abort',()=>cancelAnimationFrame(scrollFrame),{once:true});
      this.mobileMedia.addEventListener('change',()=>this.syncMobile(),options);
      this.mobile?.querySelector('[data-vita-mobile-submit]').addEventListener('click',()=>{
        const form=this.activeForm();
        if(!form||this.busy)return;
        const panel=form.closest('[data-panel]');
        if(panel?.hidden)this.querySelector('carisma-delivery-options').selectTab(panel.dataset.panel);
        form.requestSubmit();
      },options);
      if(this.mobile){
        this.mobileResize=new ResizeObserver(()=>this.reserveMobileSpace());this.mobileResize.observe(this.mobile);
      }
      this.variants=JSON.parse(this.querySelector('[data-delivery-variants]')?.textContent||'[]');
      this.addEventListener('click',event=>{const card=event.target.closest('[data-vita-pack]');if(card&&!this.busy&&!card.disabled)this.select(card.dataset.id);},options);
      this.forms.forEach(form=>form.addEventListener('submit',event=>this.add(event),options));
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-vita-variant]')&&!this.busy)this.select(event.target.value);
        event.stopPropagation();
      },options);
      const query=new URL(location.href).searchParams.get('variant');
      this.select(this.variants.find(v=>String(v.id)===query)?.id||this.querySelector('carisma-delivery-options')?.dataset.selectedId||this.variants[0]?.id,false);
      this.syncMobile();
    }
    activeForm(){return this.forms?.find(form=>!form.closest('[data-panel]')?.hidden)||this.forms?.[0];}
    reserveMobileSpace(){
      if(!this.mobile)return;
      this.root.style.setProperty('--carisma-mobile-cart-height',`${this.mobile.hidden?0:Math.ceil(this.mobile.getBoundingClientRect().height)}px`);
    }
    syncMobile(){
      if(!this.mobile)return;
      const form=this.activeForm(),variant=this.selected;
      this.mobile.hidden=!form||!variant||!this.mobileMedia.matches;
      const visible=!this.mobile.hidden&&this.scrollReady;
      this.mobile.classList.toggle('is-visible',visible);
      this.mobile.inert=!visible;
      this.mobile.setAttribute('aria-hidden',String(!visible));
      this.root.classList.toggle('carisma-has-vita-mobile',visible);
      if(form&&variant){
        this.mobile.querySelector('[data-vita-mobile-price]').textContent=variant.price;
        this.mobile.querySelector('[data-vita-mobile-name]').textContent=variant.title;
        const button=this.mobile.querySelector('[data-vita-mobile-submit]');
        button.disabled=this.busy||!variant.available;
        button.textContent=this.busy?form.dataset.addingLabel:variant.available?form.dataset.addLabel:form.dataset.soldOutLabel;
        const status=this.mobile.querySelector('[data-vita-mobile-status]'),source=form.querySelector('[data-vita-status]');
        status.replaceChildren(...[...source.childNodes].map(node=>node.cloneNode(true)));status.hidden=source.hidden;
      }
      this.reserveMobileSpace();
    }
    select(id,updateUrl=true) {
      const variant=this.variants.find(v=>String(v.id)===String(id));
      if(!variant)return;
      this.selected=variant;
      this.querySelectorAll('[data-vita-pack]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.id===String(id))));
      this.forms.forEach(form=>{
        form.elements.namedItem('id').value=String(id);
        form.elements.namedItem('quantity').value=variant.min||1;
        const price=form.querySelector('[data-vita-price]'),name=form.querySelector('[data-vita-name]');
        if(price)price.textContent=variant.price;
        if(name)name.textContent=variant.title;
        const button=form.querySelector('[data-vita-submit]');
        button.disabled=this.busy||!variant.available;
        button.textContent=variant.available?form.dataset.addLabel:form.dataset.soldOutLabel;
      });
      this.querySelector('carisma-delivery-options').dataset.selectedId=String(id);
      this.syncMobile();
      if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState({},'',url);}
    }
    async add(event) {
      event.preventDefault();
      const form=event.currentTarget,button=form.querySelector('[data-vita-submit]');
      if(this.busy||button.disabled||!form.reportValidity())return;
      const data=new FormData(form);
      if(!data.get('selling_plan'))data.delete('selling_plan');
      this.busy=true;
      const lifecycle=this.abort;
      this.forms.forEach(item=>item.querySelectorAll('button,select').forEach(control=>{control.dataset.wasDisabled=String(control.disabled);control.disabled=true;}));
      button.textContent=form.dataset.addingLabel;
      const status=form.querySelector('[data-vita-status]');status.hidden=true;
      this.syncMobile();
      const drawer=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      const sections=drawer?.getSectionsToRender?.().map(item=>item.id)||['cart-icon-bubble'];
      data.set('sections',[...new Set(sections)].join(','));data.set('sections_url',location.pathname);
      drawer?.setActiveElement?.(button);
      let added=false;
      try {
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
        const result=await response.json();
        if(!this.isConnected||this.abort!==lifecycle)return;
        if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:form.dataset.errorLabel||'Could not add this pack. Please try again.');
        added=true;status.textContent=form.dataset.addedLabel;status.hidden=false;
        if(drawer?.renderContents)await drawer.renderContents(result);
        else {
          const link=document.createElement('a');link.href=this.dataset.root+'cart';link.textContent=' '+form.dataset.viewLabel;status.append(link);
        }
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
          try {const publication=publish(PUB_SUB_EVENTS.cartUpdate,{source:'vita-delivery',cartData:result});publication?.catch?.(()=>{});}catch(_){}
        }
      } catch(error){status.hidden=false;status.textContent=added?'Added to cart. Open your cart to view the latest contents.':error.message;}
      finally{this.busy=false;this.forms.forEach(item=>item.querySelectorAll('button,select').forEach(control=>{control.disabled=control.dataset.wasDisabled==='true';delete control.dataset.wasDisabled;}));if(this.isConnected&&this.abort===lifecycle)this.select(this.selected?.id,false);}
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.mobileResize?.disconnect();if(this.mobile)this.append(this.mobile);this.mobileHost?.remove();this.mobileHost=null;this.root?.classList.remove('carisma-has-vita-mobile');this.root?.style.removeProperty('--carisma-mobile-cart-height');}
  }
  customElements.define('vita-delivery',VitaDelivery);
})();


